import React, { Component } from 'react'
import { object } from 'prop-types'
import acc from 'accounting'

class Ledger extends Component {
  render () {
    const { name } = this.props
    const ledger = this.props.data.get('ledger')

    return (
      <div className="ledger-data">
        <table className="table table-condensed table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Reference</th>
              <th className="text-right">Debit</th>
              <th className="text-right">Credit</th>
              <th className="text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            {ledger.map((l, k) => {

              return (
                <tr key={k}>
                  <td>{k+1}</td>
                  <td>{l.get('created_date')}</td>
                  <td>{l.get('ref')}</td>
                  <td className="text-right">{acc.formatNumber(l.get('debit'), 2)}</td>
                  <td className="text-right">{acc.formatNumber(l.get('credit'), 2)}</td>
                  <td className="text-right">{acc.formatNumber(l.get('balance'), 2)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>

        <table className="ledger-footer" width="100%">
          <tbody>
            <tr>
              <td width="75%"></td>
              <td>
                <div className="sign">
                  <em><small>Certified by:</small></em> <strong>{name.get('full_name')}</strong><br />
                  <em><small>Designation:</small></em> Assessor<br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

Ledger.propTypes = {
  data: object,
  name: object,
}

export default Ledger



// WEBPACK FOOTER //
// ./src/containers/Print/Ledger/ledger.js